import React from "react";
import {DIFF_VALUE} from "../../../constants/base";

const DataItem = ({ label, value, prevValue, targetDate }) => {
    return (
        <div style={{
            width: '25%',
            fontSize: 14
        }}>
            {label}<br />
            <p style={{
                fontSize: 16,
                fontWeight: 700,
                color: '#141414'
            }}>
                {
                    (() => {
                        try {
                            return value != null
                                ? Number(String(value).replace(/,/g, '')).toLocaleString()
                                : '';
                        } catch (e) {
                            return value;
                        }
                    })()
                }
            </p>
            {DIFF_VALUE(prevValue, value, targetDate)}
        </div>
    );
};

export default DataItem;